import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'
import { ApolloQueryResult } from '@apollo/client';


export type FindFirstCustomerCondition = {
  username: string;
}

export function useFindFirstCustomerFunc() {

  const getWhere = (condition: FindFirstCustomerCondition) => {
    const where: api.CustomerWhereInput  = {
      username: {
        equals: condition.username
      }
    }
    return where
  }

  const defaultOrderBy: api.CustomerOrderByWithRelationInput  = {
    createdAt: api.SortOrder.Desc
  }

  /// 商品取得
  const {
    load: findFirstCustomerLoad,
    refetch: findFirstCustomerRefetch,
    onResult: findFirstCustomerOnResult,
    onError: findFirstCustomerOnError,
    loading: findFirstCustomerLoading,
  } = useLazyQuery<
    api.FindFirstCustomerQuery,
    api.FindFirstCustomerQueryVariables
  >(api.FindFirstCustomerDocument, undefined)

  const findFirstCustomerFetchOrRefetch = async (variables:api.FindFirstCustomerQueryVariables) => {
    return await findFirstCustomerLoad(api.FindFirstCustomerDocument, variables, {
      fetchPolicy: 'network-only'
    }) || await findFirstCustomerRefetch(variables)
  }
  const findFirstCustomer = async ( condition: FindFirstCustomerCondition ) => {
    const where = getWhere(condition)
    // 検索実行
    const res = await findFirstCustomerFetchOrRefetch({
      where
    }) as ApolloQueryResult<api.FindFirstCustomerQuery>

    if (res && res.data?.findFirstCustomer) {
      return res.data.findFirstCustomer as api.Customer
    } else {
      return null
    }
  }

  return {
    findFirstCustomer,
    findFirstCustomerOnResult,
    findFirstCustomerOnError,
    findFirstCustomerLoading,
  };
}
